import { BaSensorData, CopyGSProductionOrder, CopyGSShipment, CopyNaraElement, CreateDLMovement, CreateGSContract, CreateGSIncomingInspection, CreateGSProcurement, CreateGSProductionOrder, CreateGSShipment, CreateMarketContract, CreateNaraElement, CreateUriProductionOrder, DeleteDLMovement, DeleteGSContract, DeleteGSIncomingInspection, DeleteGSProcurement, DeleteGSProductionOrder, DeleteGSShipment, DeleteNaraElement, DeleteUriProductionOrder, DLMovement, DLSensorData, GLSensorData, GSContract, GsCurrentStock, GsElementManagement, GSEsg, GSEsgSearch, GSIncomingInspection, GSManHourManagement, GSManHourResult, GSNotInStock, GSProcurement, GSProductionOrder, GSProductionPerformance, GSProductionStatus, GSQualityControl, GSShipmentManagement, GsStockHistory2, GSTotalMonitoring, GSWorker, GSWorkerScreen, HsSensorData, HbdKPIRowData, MarketAttributeManagement, MarketContract, MarketCopyContract, MarketCreateContract, MarketUpdateContract, MgSensorData, MSTotalMonitoring, NaraAccountManagement, NaraElement, NaraElementV2, PrintGSBarcode, ScanGSBarcode, SensorManagement, UpdateDLMovement, UpdateGSContract, UpdateGSProcurement, UpdateGSProductionOrder, UpdateGSShipment, UpdateNaraElement, UpdateUriProductionOrder, UriCalendarPlan, UriCalendarWorkerScreen, UriProductionOrder, UriProductionPerformance, UriProductionStatus, UriQualityControl, UriScheduler, UriSensorData, UriStockHistory, UriTotalMonitoring, UriWorkerScreen } from "../CustomRouteImport";
import { AccessHistory, AccountManagement, AlarmManagement, AttributeManagement, BarcodeIndex, BarcodePrint, BarcodePrintElement, BarcodePrintLot, BarcodePrintSerial, BarcodePrintStock, BarcodeScan, CalendarPlan, CategoryManagement, CategoryManagementV2, ClaimInfo, ClaimList, CompanyInformation, CompanySelect, CompanySelectFromG, Contract, CopyContract, CopyElement, CopyInvoice, CopyProcesses, CopyProcurement, CopyProductionOrder, CopyShipment, CopyWorkOrder, CoreElementManagement, Cost, CountData, CreateAccount, CreateContract, CreateDrawingMangement, CreateElement, CreateEquipment, CreateFailedProductionOrder, CreateFailedReason, CreateIncomingInspection, CreateInvoice, CreateMallElement, CreateMallOrder, CreateMallQnA, CreateProcesses, CreateProcurement, CreateProductionOrder, CreateShipment, CreateShipmentInspection, CreateShipmentInspectionItem, CreateShipmentInspectionLog, CreateTeam, CreateWorker, CreateWorkOrder, CreateWorkOrderLog, CurrentStock, CurrentStockV2, CurrentStockV3, Dashboard, DeleteAccount, DeleteAttributes, DeleteCategory, DeleteContract, DeleteCoreElements, DeleteDrawingMangement, DeleteElement, DeleteEquipment, DeleteFailedReason, DeleteFile, DeleteFolder, DeleteIncomingInspection, DeleteInvoice, DeleteMallCategory, DeleteMallElement, DeleteMallOrder, DeleteMallQnA, DeleteMallUser, DeleteNotInStock, DeleteProcesses, DeleteProcurement, DeleteProductionOrder, DeleteShipment, DeleteShipmentInspection, DeleteShipmentInspectionItem, DeleteShipmentInspectionLog, DeleteTeam, DeleteType, DeleteUser, DeleteWorkOrder, DrawingManagement, ElementManagement, ElementManagementV2, EquipmentManagement, EquipmentStatus, FailedProductionOrder, FailedReason, FileManagement, FindEmail, FindPw, IncomingInspection, Incomplete, InquiryInfo, InquiryList, InvoiceManagement, Join, KPIMonitoring, Login, Mall2RedirectHandler, MallCart, MallCategoryManagement, MallElementManagement, MallMain, MallMypage, MallMypageInfo, MallMypageOrderList, MallMypageQnaList, MallOrderManagement, MallProductAll, MallProductDetail, MallProductList, MallProductOrder, MallProductQna, MallQna, MallQnaList, MallQnAManagement, MallSignEmailFind, MallSignJoin, MallSignLogin, MallSignPwFind, MallSiteMap, MallUserManagement, ManHourManagement, ManHourResult, MonitoringIndex, MonitoringMaterial, MonitoringProduction, MonitoringQuality, MonitoringTotal, MultiStock, MyProfile, NotFound, NotInStock, OAuth2RedirectHandler, ProcessManagement, Procurement, Production, ProductionHistory, ProductionOrder, ProductionPerformance, ProductionStatus, QualityControl, ReProductionOrder, SafetyManagement, Scheduler, Shipment, ShipmentInspection, ShipmentInspectionItem, ShipmentInspectionLog, ShipmentV2, StockHistory, StockHistoryV2, StockMoving, StockMovingLogs, StockPlaceHistory, TeamManagement, TmpHmdData, TypeManagement, UpdateAccount, UpdateContract, UpdateElement, UpdateEquipment, UpdateFailedReason, UpdateInvoice, UpdateMallElement, UpdateMallOrder, UpdateMallQnA, UpdateMallUser, UpdateProcesses, UpdateProcurement, UpdateProductionOrder, UpdateShipment, UpdateShipmentInspection, UpdateShipmentInspectionItem, UpdateShipmentInspectionLog, UpdateStockHistory, UpdateTeam, UpdateUser, UpdateWorker, UpdateWorkOrder, UserManagement, Worker, WorkerScreen, WorkOrderManagement } from "../RouteImport";
import RouteLayout from "../layouts/RouteLayout";

export const userRoutes = [
  { path: '*', element: <NotFound /> },

  {
    path: '/', element: <RouteLayout />,
    children: [
      { path: '', element: <Login /> },

      {// oauth2
        path: 'oauth2/redirect', element: <OAuth2RedirectHandler />,
      },
      {// auth
        path: 'sign', element: <RouteLayout />,
        children: [
          { path: '', element: <Login /> },
          { path: 'join', element: <Join /> },
          { path: 'email/find', element: <FindEmail /> },
          { path: 'pw/find', element: <FindPw /> },
        ]
      },
      { // 가입코드
        path: 'companySelect', element: <RouteLayout />,
        children: [
          { path: '', element: <CompanySelect /> },
          { path: 'google', element: <CompanySelectFromG /> }
        ]
      },

      { // 스프링보드(대시보드)
        path: 'dashboard', element: <Dashboard />,
      },
      { // 문의
        path: 'inquiry', element: <RouteLayout />,
        children: [
          { path: '', element: <InquiryList /> },
          { path: ':inquiryId', element: <InquiryInfo />, },
        ],
      },

      { // 시스템
        path: 'system', children: [
          { // 사용자
            path: 'user', element: <RouteLayout />,
            children: [
              { path: '', element: <UserManagement /> },
              {
                path: 'worker', element: <RouteLayout />,
                children: [
                  { path: 'create', element: <CreateWorker />, },
                  { path: 'update', element: <UpdateWorker />, },
                ],
              },
              { path: 'update', element: <UpdateUser />, },
              { path: 'delete', element: <DeleteUser />, },
            ],
          },
          { // 팀
            path: 'team', element: <RouteLayout />,
            children: [
              { path: '', element: <TeamManagement /> },
              { path: 'create', element: <CreateTeam />, },
              { path: 'update', element: <UpdateTeam />, },
              { path: 'delete', element: <DeleteTeam />, },
            ],
          },
          { // 설정
            path: 'types', element: <RouteLayout />,
            children: [
              { path: '', element: <TypeManagement /> },
              { path: 'delete', element: <DeleteType />, },
            ],
          },
          { // 핵심지표제품
            path: 'coreElement', element: <RouteLayout />,
            children: [
              { path: '', element: <CoreElementManagement /> },
              { path: 'delete', element: <DeleteCoreElements />, },
            ],
          },
          { // 알람
            path: 'alarm', element: <AlarmManagement />,
          },
          { // 내정보
            path: 'myProfile', element: <MyProfile />,
          },
          { // 회사정보
            path: 'companyInformation', element: <CompanyInformation />,
          },
        ],
      },
      { // 사용자
        path: 'user', element: <RouteLayout />,
        children: [
          { path: '', element: <UserManagement /> },
          {
            path: 'worker', element: <RouteLayout />,
            children: [
              { path: 'create', element: <CreateWorker />, },
              { path: 'update', element: <UpdateWorker />, },
            ],
          },
          { path: 'update', element: <UpdateUser />, },
          { path: 'delete', element: <DeleteUser />, },
        ],
      },
      { // 팀
        path: 'team', element: <RouteLayout />,
        children: [
          { path: '', element: <TeamManagement /> },
          { path: 'create', element: <CreateTeam />, },
          { path: 'update', element: <UpdateTeam />, },
          { path: 'delete', element: <DeleteTeam />, },
        ],
      },

      { // 기준정보
        path: 'baseInformation',
        children: [
          { // 물품정보
            path: 'element', element: <RouteLayout />,
            children: [
              { // 패밀리3 물품정보
                path: '', element: <ElementManagement />
              },
              { // 패밀리5 물품정보
                path: 'v2', element: <RouteLayout />,
                children: [
                  { path: '', element: <ElementManagementV2 />, },
                  { path: 'copy', element: <CopyElement />, },
                  { path: 'create', element: <CreateElement />, },
                  { path: 'update', element: <UpdateElement />, },
                  { path: 'delete', element: <DeleteElement />, },
                ],
              },
              { path: 'copy', element: <CopyElement />, },
              { path: 'create', element: <CreateElement />, },
              { path: 'update', element: <UpdateElement />, },
              { path: 'delete', element: <DeleteElement />, },
              { // 나라장터 물품정보
                path: 'nara', element: <RouteLayout />,
                children: [
                  { // 패밀리3 나라장터 물품정보
                    path: '', element: <NaraElement />
                  },
                  { // 패밀리5 나라장터 물품정보
                    path: 'v2', element: <RouteLayout />,
                    children: [
                      { path: '', element: <NaraElementV2 />, },
                      { path: 'copy', element: <CopyNaraElement />, },
                      { path: 'create', element: <CreateNaraElement />, },
                      { path: 'update', element: <UpdateNaraElement />, },
                      { path: 'delete', element: <DeleteNaraElement />, },
                    ],
                  },
                  { path: 'copy', element: <CopyNaraElement />, },
                  { path: 'create', element: <CreateNaraElement />, },
                  { path: 'update', element: <UpdateNaraElement />, },
                  { path: 'delete', element: <DeleteNaraElement />, },
                ],
              },
              { // 경서 물품정보
                path: 'gs', element: <RouteLayout />,
                children: [
                  { path: '', element: <GsElementManagement /> },
                  { path: 'copy', element: <CopyElement />, },
                  { path: 'create', element: <CreateElement />, },
                  { path: 'update', element: <UpdateElement />, },
                  { path: 'delete', element: <DeleteElement />, },
                ],
              },
            ],
          },
          { // 패밀리
            path: 'category', element: <RouteLayout />,
            children: [
              { // 패밀리3 패밀리
                path: '', element: <CategoryManagement />
              },
              { // 패밀리5 패밀리
                path: 'v2', element: <RouteLayout />,
                children: [
                  { path: '', element: <CategoryManagementV2 />, },
                  { path: 'delete', element: <DeleteCategory />, },
                ],
              },
              { path: 'delete', element: <DeleteCategory />, },
            ],
          },
          { // 항목
            path: 'attributes', element: <RouteLayout />,
            children: [
              { path: '', element: <AttributeManagement /> },
              { path: 'delete', element: <DeleteAttributes />, },
              { // 나라장터 항목
                path: 'market', element: <RouteLayout />,
                children: [
                  { path: '', element: <MarketAttributeManagement /> },
                  { path: 'delete', element: <DeleteAttributes />, },
                ]
              }
            ],
          },
          { // 거래처
            path: 'account', element: <RouteLayout />,
            children: [
              { path: '', element: <AccountManagement /> },
              { // 나라장터 거래처
                path: 'nara', element: <RouteLayout />,
                children: [
                  { path: '', element: <NaraAccountManagement /> },
                  { path: 'create', element: <CreateAccount />, },
                  { path: 'update', element: <UpdateAccount />, },
                  { path: 'delete', element: <DeleteAccount />, },
                ]
              },
              { path: 'create', element: <CreateAccount />, },
              { path: 'update', element: <UpdateAccount />, },
              { path: 'delete', element: <DeleteAccount />, },
            ],
          },
          { // 공정정의
            path: 'process', element: <RouteLayout />,
            children: [
              { path: '', element: <ProcessManagement /> },
              { path: 'copy', element: <CopyProcesses />, },
              { path: 'create', element: <CreateProcesses />, },
              { path: 'update', element: <UpdateProcesses />, },
              { path: 'delete', element: <DeleteProcesses />, },
            ],
          },
          { // 작업정의
            path: 'workOrder', element: <RouteLayout />,
            children: [
              { path: '', element: <WorkOrderManagement /> },
              { path: 'copy', element: <CopyWorkOrder />, },
              { path: 'create', element: <CreateWorkOrder />, },
              { path: 'update', element: <UpdateWorkOrder />, },
              { path: 'delete', element: <DeleteWorkOrder />, },
              { path: 'workOrderLog/create', element: <CreateWorkOrderLog />, },
            ],
          },
          { // 설비
            path: 'equipment', element: <RouteLayout />,
            children: [
              { path: '', element: <EquipmentManagement /> },
              { path: 'create', element: <CreateEquipment />, },
              { path: 'update', element: <UpdateEquipment />, },
              { path: 'delete', element: <DeleteEquipment />, },
            ],
          },
          { // 도면
            path: 'drawing', element: <RouteLayout />,
            children: [
              { path: '', element: <DrawingManagement /> },
              { path: 'create', element: <CreateDrawingMangement />, },
              { path: 'delete', element: <DeleteDrawingMangement />, },
            ],
          },
          { // 파일
            path: 'file', element: <RouteLayout />,
            children: [
              { path: '', element: <FileManagement />, },
              { path: 'delete', element: <DeleteFile />, },
              {
                path: 'folder', element: <RouteLayout />,
                children: [
                  { path: 'delete', element: <DeleteFolder />, },
                ],
              },
            ],
          },
          { // 점검/검사 정의
            path: 'shipmentInspectionItem', element: <RouteLayout />,
            children: [
              { path: '', element: <ShipmentInspectionItem /> },
              { path: 'create', element: <CreateShipmentInspectionItem /> },
              { path: 'update', element: <UpdateShipmentInspectionItem /> },
              { path: 'delete', element: <DeleteShipmentInspectionItem /> },
            ]
          },
          { // 시험성적서 정의
            path: 'shipmentInspection', element: <RouteLayout />,
            children: [
              { path: '', element: <ShipmentInspection /> },
              { path: 'create', element: <CreateShipmentInspection /> },
              { path: 'update', element: <UpdateShipmentInspection /> },
              { path: 'delete', element: <DeleteShipmentInspection /> },
            ]
          }
        ],
      },

      { // 주문
        path: 'order', children: [
          { // 수주
            path: 'contract', element: <RouteLayout />,
            children: [
              { path: '', element: <Contract />, },
              { path: 'copy', element: <CopyContract />, },
              { path: 'create', element: <CreateContract />, },
              { path: 'update', element: <UpdateContract />, },
              { path: 'delete', element: <DeleteContract />, },
              { // 나라장터 수주
                path: 'market', element: <RouteLayout />,
                children: [
                  { path: '', element: <MarketContract />, },
                  { path: 'copy', element: <MarketCopyContract />, },
                  { path: 'create', element: <MarketCreateContract />, },
                  { path: 'create/market', element: <CreateMarketContract />, },
                  { path: 'update', element: <MarketUpdateContract />, },
                  { path: 'delete', element: <DeleteContract />, },
                ],
              },
              { // 경서 수주
                path: 'gs', element: <RouteLayout />,
                children: [
                  { path: '', element: <GSContract />, },
                  { path: 'create', element: <CreateGSContract />, },
                  { path: 'update', element: <UpdateGSContract />, },
                  { path: 'delete', element: <DeleteGSContract />, },
                ],
              },
            ],
          },
          { // 발주
            path: 'procurement', element: <RouteLayout />,
            children: [
              { path: '', element: <Procurement />, },
              { path: 'copy', element: <CopyProcurement />, },
              { path: 'create', element: <CreateProcurement />, },
              { path: 'update', element: <UpdateProcurement />, },
              { path: 'delete', element: <DeleteProcurement />, },
              { // 경서 발주
                path: 'gs', element: <RouteLayout />,
                children: [
                  { path: '', element: <GSProcurement />, },
                  { path: 'create', element: <CreateGSProcurement />, },
                  { path: 'update', element: <UpdateGSProcurement />, },
                  { path: 'delete', element: <DeleteGSProcurement />, },
                ],
              },
            ],
          },
          { // 미입고관리?
            path: 'procurementManagement', element: <RouteLayout />,
            children: [
              { path: '', element: <NotInStock />, },
              { path: 'delete', element: <DeleteNotInStock />, },
              { path: 'gs', element: <GSNotInStock />, },
            ],
          },
          { // 발주 미입고
            path: 'incomplete', element: <RouteLayout />,
            children: [
              { path: '', element: <Incomplete />, },
            ],
          },
          { // 출하
            path: 'shipment', element: <RouteLayout />,
            children: [
              { path: '', element: <Shipment />, },
              { path: 'v2', element: <ShipmentV2 />, },
              { path: 'copy', element: <CopyShipment />, },
              { path: 'create', element: <CreateShipment />, },
              { path: 'update', element: <UpdateShipment />, },
              { path: 'delete', element: <DeleteShipment />, },
              { // 경서 출하
                path: 'gs', element: <RouteLayout />,
                children: [
                  { path: '', element: <GSShipmentManagement />, },
                  { path: 'copy', element: <CopyGSShipment />, },
                  { path: 'create', element: <CreateGSShipment />, },
                  { path: 'update', element: <UpdateGSShipment />, },
                  { path: 'delete', element: <DeleteGSShipment />, },
                ],
              },
            ],
          },
          { // 송장관리
            path: 'invoice', element: <RouteLayout />,
            children: [
              { path: '', element: <InvoiceManagement />, },
              // { path: 'copy', element: <CopyInvoice />, },
              // { path: 'create', element: <CreateInvoice />, },
              { path: 'update', element: <UpdateInvoice />, },
              // { path: 'delete', element: <DeleteInvoice />, },
            ],
          },
          { // 도면
            path: 'drawing', element: <RouteLayout />,
            children: [
              { path: '', element: <DrawingManagement /> },
              { path: 'create', element: <CreateDrawingMangement />, },
              { path: 'delete', element: <DeleteDrawingMangement />, },
            ],
          },
        ],
      },

      { // 재고
        path: 'stock', element: <RouteLayout />,
        children: [
          { // 현재고
            path: 'current', element: <RouteLayout />,
            children: [
              { path: '', element: <CurrentStock />, },
              { path: 'v2', element: <CurrentStockV2 />, },
              { path: 'v3', element: <CurrentStockV3 />, },
              { // 경서 현재고
                path: 'gs', element: <RouteLayout />,
                children: [
                  { path: '', element: <GsCurrentStock /> },
                ],
              },
            ],
          },
          { // 다중처리
            path: 'multi', element: <RouteLayout />,
            children: [
              { path: 'In', element: <MultiStock type={'In'} />, }, // 다중 입고
              { path: 'Put', element: <MultiStock type={'Put'} />, }, // 다중 출고
              { path: 'Consume', element: <MultiStock type={'Consume'} />, }, // 다중 차감
              { path: 'Out', element: <MultiStock type={'Out'} />, }, // 다중 출하
            ],
          },
          { // 재고이동
            path: 'moving', element: <RouteLayout />,
            children: [
              { path: '', element: <StockMoving /> },
              { path: 'logs', element: <StockMovingLogs /> },
            ]
          },
          { // 재고위치추적
            path: 'placeHistory', element: <StockPlaceHistory />
          },
          { // 재고상세이력
            path: 'history', element: <RouteLayout />,
            children: [
              { // 패밀리3 재고상세이력
                path: '', element: <StockHistory />,
              },
              { path: 'update', element: <UpdateStockHistory />, },
              { // 패밀리5 재고상세이력
                path: 'v2', element: <RouteLayout />,
                children: [
                  { path: '', element: <StockHistoryV2 /> },
                  { path: 'update', element: <UpdateStockHistory /> },
                ]
              },
              { // 우리창호 재고상세이력
                path: 'uri', element: <UriStockHistory />,
              },
              { // 경서 재고상세이력
                path: 'gs', element: <GsStockHistory2 />,
              },

            ],
          },
        ],
      },

      { // 생산관리
        path: 'production', children: [
          { // 작업지시
            path: 'order', element: <RouteLayout />,
            children: [
              { path: '', element: <ProductionOrder />, },
              { path: 'copy', element: <CopyProductionOrder />, },
              { path: 'create', element: <CreateProductionOrder />, },
              { path: 'update', element: <UpdateProductionOrder />, },
              { path: 'delete', element: <DeleteProductionOrder />, },
              { // 우리창호 작업지시
                path: 'uri', element: <RouteLayout />,
                children: [
                  { path: '', element: <UriProductionOrder />, },
                  { path: 'create', element: <CreateUriProductionOrder />, },
                  { path: 'update', element: <UpdateUriProductionOrder />, },
                  { path: 'delete', element: <DeleteUriProductionOrder />, },
                ],
              },
              { // 경서 작업지시
                path: 'gs', element: <RouteLayout />,
                children: [
                  { path: '', element: <GSProductionOrder />, },
                  { path: 'copy', element: <CopyGSProductionOrder />, },
                  { path: 'create', element: <CreateGSProductionOrder />, },
                  { path: 'update', element: <UpdateGSProductionOrder />, },
                  { path: 'delete', element: <DeleteGSProductionOrder />, },
                ],
              },
            ],
          },
          { // 작업일정
            path: 'scheduler', element: <RouteLayout />,
            children: [
              { path: '', element: <Scheduler />, },
              { path: 'uri', element: <UriScheduler />, },
            ],
          },
          { // 작업현황
            path: 'status', element: <RouteLayout />,
            children: [
              { path: '', element: <ProductionStatus />, },
              { path: 'uri', element: <UriProductionStatus />, },
              { path: 'gs', element: <GSProductionStatus />, },
            ],
          },
          { // 작업실적
            path: 'performance', element: <RouteLayout />,
            children: [
              { path: '', element: <ProductionPerformance />, },
              { path: 'uri', element: <UriProductionPerformance />, },
              { path: 'gs', element: <GSProductionPerformance />, },
            ],
          },
          { // 일일계획
            path: 'calendar', element: <RouteLayout />,
            children: [
              { path: '', element: <CalendarPlan />, },
              { path: 'uri', element: <UriCalendarPlan />, },
            ],
          },
          { // 작업이력
            path: 'history', element: <ProductionHistory />,
          },
          { // 불량재작업
            path: 'failedOrder', element: <RouteLayout />,
            children: [
              { path: '', element: <FailedProductionOrder />, },
              { path: 'recreate', element: <CreateFailedProductionOrder />, },
            ],
          },
          { // 재작업이력
            path: 'reOrder', element: <RouteLayout />,
            children: [
              { path: '', element: <ReProductionOrder />, },
            ],
          },
          { // 공수관리
            path: 'manHour', element: <RouteLayout />,
            children: [
              {
                path: '', element: <RouteLayout />,
                children: [
                  { path: '', element: <ManHourManagement /> },
                  {
                    path: 'result', element: <ManHourResult />,
                    children: [
                      { path: 'worker', element: <Worker /> },
                      // {path: 'production', element: <Production />},
                    ]
                  },
                ]
              },
              { // 경서 공수관리
                path: 'gs', element: <RouteLayout />,
                children: [
                  { path: '', element: <GSManHourManagement /> },
                  {
                    path: 'result', element: <GSManHourResult />,
                    children: [
                      { path: 'worker', element: <GSWorker /> },
                      // {path: 'production', element: <Production />},
                    ]
                  },
                ]
              },
            ],
          },
          { // 원가확인
            path: 'cost', element: <Cost />,
          },
        ],
      },

      { // 제조실행
        path: 'working', element: <RouteLayout />,
        children: [
          { // 작업실행
            path: '', element: <WorkerScreen />,
          },
          { // 우리창호 작업실행
            path: 'uri', element: <UriWorkerScreen />,
          },
          { // 경서 작업실행
            path: 'gs', element: <GSWorkerScreen />,
          },
          { // 대림비엔코 작업실행
            path: 'dl', element: <RouteLayout />,
            children: [
              { // 공정이동표
                path: 'movement', element: <RouteLayout />,
                children: [
                  { path: '', element: <DLMovement />, },
                  { path: 'create', element: <CreateDLMovement />, },
                  { path: 'update', element: <UpdateDLMovement />, },
                  { path: 'delete', element: <DeleteDLMovement />, },
                ],
              },
            ],
          },
          { // 설비가동
            path: 'equipment', element: <EquipmentStatus />,
          },
        ],
      },

      { // 품질
        path: 'quality', children: [
          { // 품질관리
            path: 'control', element: <RouteLayout />,
            children: [
              { path: '', element: <QualityControl />, },
              { path: 'uri', element: <UriQualityControl />, },
              { path: 'gs', element: <GSQualityControl />, },
            ],
          },
          { // 불량사유
            path: 'failedReason', element: <RouteLayout />,
            children: [
              { path: '', element: <FailedReason />, },
              { path: 'create', element: <CreateFailedReason />, },
              { path: 'update', element: <UpdateFailedReason />, },
              { path: 'delete', element: <DeleteFailedReason />, },
            ],
          },
          { // 수입검사
            path: 'incomingInspection', element: <RouteLayout />,
            children: [
              { path: '', element: <IncomingInspection />, },
              { path: 'create', element: <CreateIncomingInspection />, },
              { path: 'delete', element: <DeleteIncomingInspection />, },
              { // 경서 조도측정
                path: 'gs', element: <RouteLayout />,
                children: [
                  { path: '', element: <GSIncomingInspection />, },
                  { path: 'create', element: <CreateGSIncomingInspection />, },
                  { path: 'delete', element: <DeleteGSIncomingInspection />, },
                ],
              },
            ],
          },
          { // 시험성적서
            path: 'shipmentInspectionLog', element: <RouteLayout />,
            children: [
              { path: '', element: <ShipmentInspectionLog /> },
              { path: 'create', element: <CreateShipmentInspectionLog /> },
              { path: 'update', element: <UpdateShipmentInspectionLog /> },
              { path: 'delete', element: <DeleteShipmentInspectionLog /> },
            ]
          },
          { // 고객 클레임 관리
            path: 'claim', element: <RouteLayout />,
            children: [
              { path: '', element: <ClaimList /> },
            ],
          },
        ],
      },

      { // 모니터링
        path: 'monitoring',
        children: [
          {
            path: '', element: <MonitoringIndex />,
            children: [
              { path: 'total', element: <MonitoringTotal /> },
              { path: 'material', element: <MonitoringMaterial /> },
              { path: 'production', element: <MonitoringProduction /> },
              { path: 'quality', element: <MonitoringQuality /> },
            ]
          },
          {
            path: 'company', element: <RouteLayout />,
            children: [
              { // 우리창호 모니터링
                path: 'uri', element: <RouteLayout />,
                children: [
                  { path: '', element: <UriTotalMonitoring />, },
                  { path: 'working', element: <UriCalendarWorkerScreen />, },
                ],
              },
              { // 경서 모니터링
                path: 'gs', element: <GSTotalMonitoring />,
              },
              { // 엠에스코리아 모니터링
                path: 'ms', element: <MSTotalMonitoring />,
              },
            ],
          },
          { // 센서 데이터
            path: 'sensorData', element: <RouteLayout />,
            children: [
              { path: '', element: <TmpHmdData />, },
              { path: 'count', element: <CountData />, },
              { path: 'dl', element: <DLSensorData />, },
              { path: 'hsland', element: <HsSensorData />, },
              { path: 'uri', element: <UriSensorData />, },
              { path: 'gl', element: <GLSensorData />, },
              { path: 'ba', element: <BaSensorData />, },
              { path: 'mg', element: <MgSensorData />, },

              // 팸텍 설비 센서 모니터링
              { path: 'ft', element: <SensorManagement />, },
            ],
          },
          { // 작업일정
            path: 'scheduler', element: <RouteLayout />,
            children: [
              { path: '', element: <Scheduler />, },
              { path: 'uri', element: <UriScheduler />, },
            ],
          },
          { // 사용자 접속현황
            path: 'accessHistory', element: <AccessHistory />,
          },
          { // ESG 모니터링
            path: 'fems', element: <RouteLayout />,
            children: [
              { // 경서 ESG 모니터링
                path: 'gs', element: <RouteLayout />,
                children: [
                  { path: '', element: <GSEsg /> },
                  { path: 'search', element: <GSEsgSearch /> },
                ]
              },
            ],
          },
          { // KPI 모니터링
            path: 'kpi', element: <RouteLayout />,
            children: [
              { path: '', element: <KPIMonitoring /> },
              { // 한바다 KPI 모니터링
                path: 'hbd', element: <RouteLayout />,
                children: [
                  { path: ':id', element: <HbdKPIRowData /> },
                ]
              }
            ]
          },
          { // 안전관리 모니터링
            path: 'safety', element: <SafetyManagement />,
          },
        ],
      },

      { // 바코드
        path: 'barcode',
        element: <RouteLayout />,
        children: [
          {// 바코드 메인 페이지
            path: '', element: <BarcodeIndex />
          },
          {// 바코드 스캔 결과 페이지
            path: 'scan', element: <BarcodeScan />,
          },
          {// 바코드 프린트 페이지
            path: 'print', element: <RouteLayout />,
            children: [
              { path: '', element: <BarcodePrint /> },
              { path: 'element', element: <BarcodePrintElement /> },
              { path: 'stock', element: <BarcodePrintStock /> },
              { path: 'lot', element: <BarcodePrintLot /> },
              { path: 'serial', element: <BarcodePrintSerial /> },
            ]
          },
          { // 경서 바코드
            path: 'gs', element: <RouteLayout />,
            children: [
              { path: 'scan', element: <ScanGSBarcode />, },
              { path: 'print', element: <PrintGSBarcode />, },
            ],
          },
        ]
      },

      { // 고객주문관리
        path: 'mallManagement', element: <RouteLayout />,
        children: [
          { // 주문관리
            path: 'order', element: <RouteLayout />,
            children: [
              { path: '', element: <MallOrderManagement />, },
              { path: 'create', element: <CreateMallOrder />, },
              { path: 'update', element: <UpdateMallOrder />, },
              { path: 'delete', element: <DeleteMallOrder />, },
            ],
          },
          { // 문의관리
            path: 'qna', element: <RouteLayout />,
            children: [
              { path: '', element: <MallQnAManagement />, },
              { path: 'create', element: <CreateMallQnA />, },
              { path: 'update', element: <UpdateMallQnA />, },
              { path: 'delete', element: <DeleteMallQnA />, },
            ],
          },
          { // 판매물품관리
            path: 'element', element: <RouteLayout />,
            children: [
              { path: '', element: <MallElementManagement />, },
              { path: 'create', element: <CreateMallElement />, },
              { path: 'update', element: <UpdateMallElement />, },
              { path: 'delete', element: <DeleteMallElement />, },
            ],
          },
          { // 카테고리관리
            path: 'category', element: <RouteLayout />,
            children: [
              { path: '', element: <MallCategoryManagement />, },
              { path: 'delete', element: <DeleteMallCategory />, },
            ],
          },
          { // 고객관리
            path: 'user', element: <RouteLayout />,
            children: [
              { path: '', element: <MallUserManagement />, },
              { path: 'update', element: <UpdateMallUser />, },
              { path: 'delete', element: <DeleteMallUser />, },
            ],
          },
        ],
      },
    ]
  },
];